<app-form-section
  title="Almacenes"
  icon="warehouse"
  color="indigo"
  class="space-y-4">
  <div class="space-y-4">
    <app-toggle-option
      [formControl]="availableInAllCtrl"
      title="Disponible en todos los almacenes"
      description="Activa esta opción si el material estará disponible en todos los almacenes del sistema"
      icon="warehouse"
      iconColor="indigo">
    </app-toggle-option>

    <mat-form-field appearance="fill" class="w-full" *ngIf="!availableInAllCtrl.value">
      <mat-label>Seleccionar Almacenes</mat-label>
      <mat-select [formControl]="warehouseMultiCtrl" multiple #warehouseSelect>
        <!-- Barra de búsqueda con checkbox de seleccionar todos -->
        <div class="sticky top-0 z-10 bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
          <div class="flex items-center gap-2 p-3">
            <mat-checkbox
              [checked]="isAllFilteredSelected()"
              [indeterminate]="isSomeFilteredSelected() && !isAllFilteredSelected()"
              (change)="toggleSelectAllFiltered()"
              (click)="$event.stopPropagation()"
              color="primary"
              class="flex-shrink-0">
            </mat-checkbox>
            <div class="flex-1">
              <input
                #searchInput
                [formControl]="warehouseFilterCtrl"
                placeholder="Buscar almacenes..."
                (click)="$event.stopPropagation()"
                (keydown)="$event.stopPropagation()"
                class="w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:text-white"
                type="text">
            </div>
            <span class="text-xs text-gray-500 dark:text-gray-400 whitespace-nowrap">
              {{ getSelectedFilteredCount() }}/{{ getFilteredCount() }}
            </span>
          </div>
        </div>

        <!-- Opciones de almacenes -->
        <mat-option *ngFor="let warehouse of filteredWarehouses | async" [value]="warehouse">
          <span *ngIf="warehouse.externalKeys?.code">
            <b>{{ warehouse.externalKeys.code }}</b> -
          </span>
          {{ warehouse.name }}
        </mat-option>
      </mat-select>
      <button mat-icon-button matSuffix *ngIf="warehouseMultiCtrl.value?.length > 0"
              (click)="clearSelection(); $event.stopPropagation();"
              matTooltip="Limpiar selección"
              type="button">
        <mat-icon class="text-gray-500">close</mat-icon>
      </button>
      <mat-error *ngIf="warehouseMultiCtrl.hasError('required') && warehouseMultiCtrl.touched">
        Debe seleccionar al menos un almacén
      </mat-error>
    </mat-form-field>

    <div class="flex items-start gap-2 p-3 bg-blue-50 dark:bg-blue-900/20 rounded-md text-sm text-gray-700 dark:text-gray-300" *ngIf="availableInAllCtrl.value">
      <mat-icon class="text-blue-500 flex-shrink-0" style="font-size: 20px; width: 20px; height: 20px;">info_outline</mat-icon>
      <span>Este material estará disponible en todos los almacenes del sistema.</span>
    </div>
  </div>
</app-form-section>
